const rootActionPath = 'core/firstFavoriteModal';

export const FIRST_FAVORITE_MODAL_VIEW = `${rootActionPath}/VIEW`;
